import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { Field, change } from 'redux-form';
import { connect } from 'react-redux';
import { FormGroup } from 'reactstrap';
import Select from '../../../common/forms/select/Select';
import { isRequired } from '../../../../utils/validators';
import {
  getPostpaidBookingItineraryFoodGroup,
  deselectPostpaidBookingSeat,
  clearCustomers,
} from '../../../../actions';
import { GENDERS, RELATIONSHIP } from '../../../../config/constants';
import {
  DEFAULT_ID_COUNTRY_OF_ORIGIN_OPTION,
  DEFAULT_IDENTIFICATION_TYPE_ID_OPTION,
} from '../../../../config/defaults';
import { DATE_TIME_FORMAT } from '../../../../config/locale';
import CustomerInputGroup from '../../../common/forms/CustomerInputGroup';
import PassengerForm from '../../../modules/booking/passengers/PassengerForm';
import { orderBy } from '../../../../utils/array';
import FormItem from '../../../common/forms/FormItem';
import { enumToSelectOptions } from '../../../../utils/enum';
import TextInput from '../../../common/forms/input/TextInput';
import Badge from '../../../common/Badge';
import { tzNormalizeDate } from '../../../../utils/date';

// TODO: refactor and create one bookingPassengerForm
// need to get rid of getPostpaidBookingItineraryFoodGroup call
// in order to make it reusable
class PostpaidBookingPassengerForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      customerDisabled: false,
      underageDisabled: true,
      showUnderageExtraFields: false,
      grownUpPassenger: null,
      underagePassenger: null,
      relationship: null,
    };
  }

  componentDidMount() {
    this.onMount();
  }

  onMount = () => {
    const { dispatchGetPostpaidBookingItineraryFoodGroup, itineraryId } =
      this.props;

    dispatchGetPostpaidBookingItineraryFoodGroup(itineraryId);
  };

  onChangeGrownUpPassenger = (customer) => {
    const { passenger, dispatchChange, dispatchClearCustomers } = this.props;

    dispatchClearCustomers();

    const selectedCustomer = customer && customer.firstName;

    if (!selectedCustomer) {
      dispatchChange('PassengersForm', `${passenger}.kidCustomer`, null);
      dispatchChange('PassengersForm', `${passenger}.relationship`, null);
    }

    this.setState({
      grownUpPassenger: customer && customer.fullName,
      underagePassenger: null,
      relationship: null,
      showUnderageExtraFields: false,
      underageDisabled: !selectedCustomer,
    });
  };

  onChangeUnderagePassenger = (customer) => {
    const { passenger, dispatchChange } = this.props;

    const selectedCustomer = customer && customer.firstName;

    if (!selectedCustomer)
      dispatchChange('PassengersForm', `${passenger}.relationship`, null);

    this.setState({
      showUnderageExtraFields: customer && customer.firstName,
      relationship: null,
      underagePassenger: customer && customer.fullName,
    });
  };

  onChangeRelationship = (relationship) =>
    this.setState({ relationship: relationship && relationship.label });

  onClickDeselectSeat = () => {
    const {
      seatReservations,
      index,
      dispatchDeselectPostpaidBookingSeat,
      fields,
    } = this.props;

    const {
      value: seatReservationId,
      label: seatId,
      itineraryId,
    } = seatReservations[index];

    fields.remove(index);

    dispatchDeselectPostpaidBookingSeat({
      seatReservationId,
      itineraryId,
      seatId,
    });
  };

  onClickEditCustomer = (kindOfPassenger) => {
    const initialValues = this.state[`${kindOfPassenger}InitialValues`];
    const passenger = this.state[`${kindOfPassenger}Passenger`];

    if (initialValues !== passenger) {
      const jsonPassenger = JSON.parse(passenger);

      const identificationTypeId = jsonPassenger.identificationType
        ? {
            value: jsonPassenger.identificationType.id,
            label: jsonPassenger.identificationType.name,
          }
        : DEFAULT_IDENTIFICATION_TYPE_ID_OPTION;

      const newInitialValues = JSON.stringify({
        firstName: jsonPassenger.firstName,
        lastName: jsonPassenger.lastName,
        gender: GENDERS.find((gender) => gender.value === jsonPassenger.gender),
        identificationTypeId,
        idDocumentNumber: jsonPassenger.idDocumentNumber,
        idCountryOfOrigin: DEFAULT_ID_COUNTRY_OF_ORIGIN_OPTION,
        email: jsonPassenger.email,
        dateOfBirth: jsonPassenger.dob,
        mobilePhone: jsonPassenger.mobilePhone,
        id: jsonPassenger.id,
      });

      let state = {
        underageInitialValues: newInitialValues,
      };

      if (kindOfPassenger === 'grownUp')
        state = { grownUpInitialValues: newInitialValues };

      this.setState(state);
    }
  };

  render() {
    const {
      seatReservations,
      index,
      foodOptions,
      seatSelectionChangesInProgress,
      passenger,
    } = this.props;

    const {
      customerDisabled,
      underageDisabled,
      showUnderageExtraFields,
      grownUpPassenger,
      underagePassenger,
      relationship,
    } = this.state;

    let foodInput = null;
    if (foodOptions) {
      foodInput = (
        <FormGroup row>
          <FormItem label="Alimento" required>
            <Field
              name={`${passenger}.food`}
              component={Select}
              options={foodOptions}
              validate={[isRequired]}
            />
          </FormItem>
        </FormGroup>
      );
    }

    let route = null;
    let deleteButton = null;
    if (seatReservations[index]) {
      const {
        itinerary: {
          originName,
          destinationName,
          serviceName,
          departureTime,
          arrivalTime,
        },
      } = seatReservations[index];

      // departure
      const formattedDepartureDate = tzNormalizeDate({
        date: departureTime,
        format: DATE_TIME_FORMAT,
      });

      // arrival
      const formattedArrivalDate = tzNormalizeDate({
        date: arrivalTime,
        format: DATE_TIME_FORMAT,
      });

      route = (
        <>
          <div className="mr-2">({serviceName})</div>
          <div className="text-center">
            {originName}{' '}
            <p>
              <small>{formattedDepartureDate}</small>
            </p>
          </div>
          <div className="mr-3 ml-3"> &rarr; </div>
          <div className="text-center">
            {destinationName}{' '}
            <p>
              <small>{formattedArrivalDate}</small>
            </p>
          </div>
        </>
      );

      let deselectSeatFunction = null;

      if (seatSelectionChangesInProgress.size === 0) {
        deselectSeatFunction = this.onClickDeselectSeat;
      }

      deleteButton = (
        <i
          className="fa fa-times fa-2x text-danger clickable"
          role="button"
          onClick={deselectSeatFunction}
          onKeyPress={deselectSeatFunction}
          tabIndex={0}
        />
      );
    }

    let header = null;

    header = (
      <div className="clearfix">
        <div className="float-left">
          <h5>
            <div className="d-flex">
              <div className="mr-3">Pasajero {index + 1}: </div> {route}
            </div>
          </h5>
        </div>
        <div className="float-right">{deleteButton}</div>
      </div>
    );

    const underageExtraFields = showUnderageExtraFields && (
      <>
        <FormGroup row>
          <FormItem label="Relación con el Menor">
            <Field
              name={`${passenger}.relationship`}
              component={Select}
              options={enumToSelectOptions(RELATIONSHIP)}
              onChange={this.onChangeRelationship}
              validate={[isRequired]}
            />
          </FormItem>
        </FormGroup>
        <FormGroup row>
          <FormItem label="Observaciones">
            <Field
              name={`${passenger}.comments`}
              component={TextInput}
              type="textarea"
              placeholder="Observaciones"
            />
          </FormItem>
        </FormGroup>
      </>
    );

    const relationshipText =
      RELATIONSHIP.OTHER.label !== relationship
        ? `${grownUpPassenger} es ${relationship} de ${underagePassenger}`
        : `${grownUpPassenger} tiene otro tipo de relación con ${underagePassenger}`;
    const underageDetails = underagePassenger &&
      grownUpPassenger &&
      relationship && (
        <Badge color="success" text={<small>{relationshipText}</small>} />
      );

    return (
      <div>
        <hr />
        {header}
        <CustomerInputGroup
          label="Pasajero"
          labelRequired
          name={`${passenger}.passenger`}
          form="PostpaidBookingPassengersForm"
          mobilePhoneRequired
          disabled={customerDisabled}
          onChange={this.onChangeGrownUpPassenger}
          showDetails
          autoFocus
        />
        <FormGroup row>
          <FormItem label="Asiento" required>
            <Field
              name={`${passenger}.seatReservation`}
              component={Select}
              options={seatReservations}
              isDisabled
              validate={[isRequired, PassengerForm.hasValidSeat]}
            />
          </FormItem>
        </FormGroup>
        {foodInput}
        <div className="mr-3 ml-3 border rounded shadow-sm">
          <div className="pt-3 pr-3 pl-3 pb-1">
            <h5>Datos del Menor de Edad: {underageDetails}</h5>
            <CustomerInputGroup
              label="Menor de Edad"
              name={`${passenger}.kidCustomer`}
              form="PassengersForm"
              disabled={underageDisabled}
              onChange={this.onChangeUnderagePassenger}
              showDetails
            />
            {underageExtraFields}
          </div>
        </div>
      </div>
    );
  }
}

PostpaidBookingPassengerForm.propTypes = {
  index: PropTypes.number.isRequired,
  passenger: PropTypes.string.isRequired,
  foodOptions: Select.propTypes.options,
  seatReservations: Select.propTypes.options.isRequired,
  dispatchGetPostpaidBookingItineraryFoodGroup: PropTypes.func.isRequired,
  dispatchChange: PropTypes.func.isRequired,
  itineraryId: PropTypes.number.isRequired,
  dispatchDeselectPostpaidBookingSeat: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  fields: PropTypes.object.isRequired,
  seatSelectionChangesInProgress: PropTypes.instanceOf(Immutable.Set)
    .isRequired,
  dispatchClearCustomers: PropTypes.func.isRequired,
};

PostpaidBookingPassengerForm.defaultProps = {
  foodOptions: null,
};

// TODO: refactor and pass booking state from higher component
const mapStateToProps = (state, { index }) => {
  const seatReservations = state.PostpaidBookingUnit.PostpaidBooking.getIn([
    'seats',
    'seatReservations',
  ])
    .map((seatReservation) => ({
      value: seatReservation.id,
      label: seatReservation.seat.seatNumber,
      itinerary: seatReservation.itinerary || null,
      itineraryId: seatReservation.itineraryId || null,
      seatNumber: seatReservation.seat.seatNumber,
      floorNumber: seatReservation.seat.floorNumber,
    }))
    .toJS();

  const seatReservationsOrdered = orderBy(
    seatReservations,
    ['itinerary.departureTime', 'itineraryId', 'label'],
    ['asc'],
  );

  const foodGroup = state.PostpaidBookingUnit.PostpaidBooking.getIn([
    'passengers',
    'itineraryFoodGroup',
  ]);

  let foodOptions = null;
  if (foodGroup && foodGroup.foodSet) {
    foodOptions = foodGroup.foodSet.map((food) => ({
      value: food.id,
      label: food.name,
    }));
  }

  const seatSelectionChangesInProgress =
    state.PostpaidBookingUnit.PostpaidBooking.getIn([
      'seats',
      'seatSelectionChangesInProgress',
    ]);

  const { itineraryId } = seatReservations[index];

  return {
    seatReservations: seatReservationsOrdered,
    foodOptions,
    itineraryId,
    seatSelectionChangesInProgress,
  };
};

const mapDispatchToProps = {
  dispatchGetPostpaidBookingItineraryFoodGroup:
    getPostpaidBookingItineraryFoodGroup,
  dispatchChange: change,
  dispatchDeselectPostpaidBookingSeat: deselectPostpaidBookingSeat,
  dispatchClearCustomers: clearCustomers,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PostpaidBookingPassengerForm);
